var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgClockAttentionIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Clock_Attention",
    "data-name": "Clock Attention",
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_11567",
    "data-name": "Rectangle 11567",
    width: 32,
    height: 32,
    fill: "currentColor",
    opacity: 0
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_13909",
    "data-name": "Group 13909",
    transform: "translate(3.333 4.667)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_2",
    "data-name": "Subtraction 2",
    d: "M11.332,22.665A11.326,11.326,0,1,1,22.444,9.083a7.3,7.3,0,0,0-1.316-.331,10.143,10.143,0,0,0-9.2-7.53V3.577H10.736V1.222a10.138,10.138,0,0,0-9.512,9.514H3.58v1.193H1.224a10.139,10.139,0,0,0,9.512,9.514V19.088h1.193v2.355a10.1,10.1,0,0,0,2.642-.513,7.394,7.394,0,0,0,1,.914A11.252,11.252,0,0,1,11.332,22.665Zm.6-10.736H7.159V10.736h3.58V5.369h1.193v6.559Z",
    transform: "translate(0 0)",
    fill: "currentColor",
    stroke: "rgba(0,0,0,0)",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_3",
    "data-name": "Subtraction 3",
    d: "M5.666,11.333a5.667,5.667,0,1,1,5.667-5.667A5.673,5.673,0,0,1,5.666,11.333Zm0-3.751a.668.668,0,1,0,.668.667A.666.666,0,0,0,5.665,7.583ZM5.167,2V6.167h1V2Z",
    transform: "translate(14 9.999)",
    fill: "currentColor"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgClockAttentionIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Clock_Attention_icon.b43819b36f96e9cfcaa66989e0116a69.svg";